import { LocationDtoTypeEnum } from "../generated/account-client";

export const PAUSE_PERIODS = [1, 3];

function initMonths() {
  let date = new Date(2021, 0, 1);
  const months: { [month: number]: string } = {};
  for (let step = 0; step < 12; step++) {
    months[step + 1] = date.toLocaleString("en-us", { month: "short" });
    date = new Date(date.setMonth(date.getMonth() + 1));
  }

  return months;
}

function initYears() {
  let date = new Date();
  const years = [] as number[];

  for (let step = 0; step < 10; step++) {
    years.push(date.getFullYear());
    date = new Date(date.setFullYear(date.getFullYear() + 1));
  }

  return years;
}

export const CC_MONTHS = initMonths();
export const CC_YEARS = initYears();

export const BUSINESS_TYPE = [
  LocationDtoTypeEnum.Restaurant,
  LocationDtoTypeEnum.Spa,
  LocationDtoTypeEnum.Designer,
  LocationDtoTypeEnum.Dispensary,
  LocationDtoTypeEnum.Other,
];
export const ALLOWED_IMAGE_TYPES =
  "image/png,image/x-png,image/jpeg,/image/jpg";
export const MAX_IMAGE_SIZE = 10;
export const fallbackImage =
  "data:image/png;base64,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";
export const DEFAULT_ADDON_PRICE = 10;

export const DesignSizes = JSON.parse(`{
  "letter" : ["flyer", "8.5 x 11"],
  "letter-landscape" : ["flyer", "11 x 8.5"],
  "legal" : ["flyer", "8.5 x 14"],
  "legal-landscape" : ["flyer", "14 x 8.5"],
  "tabloid" : ["flyer", "11 x 17"],
  "tabloid-landscape" : ["flyer", "17 x 11"],
  "a4" : ["flyer", "8.3 x 11.7"],
  "a4-landscape" : ["flyer", "11.7 x 8.3"],
  "fb-post" : ["social", "1200 x 628"],
  "fb-story" : ["social", "1080 x 1920"],
  "insta-post" : ["social", "1080 x 1080"],
  "insta-story" : ["social", "1080 x 1920"],
  "biz-card-landscape" : ["business card", "3.5 x 2"],
  "biz-card-portrait" : ["business card", "2 x 3.5"],
  "biz-card-square" : ["business card", "2.5 x 2.5"],
  "menu-letter" : ["menu", "8.5 x 11"],
  "menu-letter-landscape" : ["menu", "11 x 8.5"],
  "menu-legal" : ["menu", "8.5 x 14"],
  "menu-legal-landscape" : ["menu", "14 x 8.5"],
  "menu-tabloid" : ["menu", "11 x 17"],
  "menu-tabloid-landscape" : ["menu", "17 x 11"],
  "menu-a4" : ["menu", "8.3 x 11.7"],
  "menu-a4-landscape" : ["menu", "11.7 x 8.3"],
  "loyalty-card-landscape" : ["loyalty card", "3.5 x 2"],
  "loyalty-card-portrait" : ["loyalty card", "2 x 3.5"],
  "kids-menu-letter-portrait" : ["menu", "8.5 x 11"],
  "kids-menu-letter-landscape" : ["menu", "11 x 8.5"],
  "kids-menu-legal-portrait" : ["menu", "8.5 x 14"],
  "kids-menu-legal-landscape" : ["menu", "14 x 8.5"],
  "kids-menu-tabloid-portrait" : ["menu", "11 x 17"],
  "kids-menu-tabloid-landscape" : ["menu", "17 x 11"],
  "kids-menu-a4-portrait" : ["menu", "8.3 x 11.7"],
  "kids-menu-a4-landscape" : ["menu", "11.7 x 8.3"],
  "comment-card-portrait" : ["comment card", "3.5 x 8.5"],
  "rack-card-portrait" : ["rack card", "3.5 x 8.5"],
  "gift-certificate-landscape" : ["gift certificate", "8.5 x 3.5"],
  "takeout-letter-trifold" : ["takeout", "11 x 8.5"],
  "takeout-letter-bifold" : ["takeout", "11 x 8.5"],
  "takeout-legal-trifold" : ["takeout", "14 x 8.5"],
  "takeout-legal-quadfold" : ["takeout", "14 x 8.5"],
  "takeout-tabloid-trifold" : ["takeout", "17 x 11"],
  "folded-menu-letter-trifold" : ["folded menu", "11 x 8.5"],
  "folded-menu-letter-bifold" : ["folded menu", "11 x 8.5"],
  "folded-menu-legal-trifold" : ["folded menu", "14 x 8.5"],
  "folded-menu-tabloid-trifold" : ["folded menu", "17 x 11"],
  "half-page-menu" : ["menu", "4.25 x 11"],
  "half-page-menu-long" : ["menu", "4.25 x 14"],
  "half-page-menu-wide" : ["menu", "5.5 x 8.5"],
  "half-page-menu-wide-landscape" : ["menu", "8.5 x 5.5"],
  "table-tent" : ["table tent", "4 x 6"],
  "table-tent-insert" : ["tabletop insert", "5 x 7"],
  "table-tent-insert-4x6" : ["tabletop insert", "4 x 6"],
  "poster" : ["poster", "22 x 28"],
  "digital-menu-board" : ["menu", "16 x 9"],
  "digital-menu-board-portrait" : ["menu", "9 x 16"],
  "menu-mailer-tabloid-trifold" : ["menu", "17 x 11"],
  "sticker-landscape" : ["sticker", "3.5 x 2"],
  "sticker-portrait" : ["sticker", "2 x 3.5"],
  "sticker-square" : ["sticker", "2.5 x 2.5"],
  "label-landscape" : ["label", "3.5 x 2"],
  "label-portrait" : ["label", "2 x 3.5"],
  "label-square" : ["label", "2.5 x 2.5"],
  "sandwich-board" : ["sandwich board", "22 x 28"],
  "logo" : ["logo", "1000 x 1000"]
}`);

export const FilterSizesMap = JSON.parse(`{
  "all-categories": [],
  "menu": ["menu-letter", "menu-letter-landscape", "menu-legal", "menu-legal-landscape", "menu-tabloid", "menu-tabloid-landscape", "menu-a4", "menu-a4-landscape", "folded-menu-letter-trifold", "folded-menu-letter-bifold", "folded-menu-legal-trifold", "folded-menu-tabloid-trifold", "menu-mailer-tabloid-trifold"],
  "digital-menu-board": ["digital-menu-board", "digital-menu-board-portrait"],
  "table-tent": [],
  "takeout": ["takeout-letter-trifold", "takeout-letter-bifold", "takeout-legal-trifold", "takeout-legal-quadfold", "takeout-tabloid-trifold"],
  "half-page-menu": ["half-page-menu", "half-page-menu-long", "half-page-menu-wide", "half-page-menu-wide-landscape"],
  "flyer": ["letter", "letter-landscape", "legal", "legal-landscape", "tabloid", "tabloid-landscape", "a4", "a4-landscape"],
  "kids-menu": ["kids-menu-letter-portrait", "kids-menu-letter-landscape", "kids-menu-legal-portrait", "kids-menu-legal-landscape", "kids-menu-tabloid-portrait", "kids-menu-tabloid-landscape", "kids-menu-a4-portrait", "kids-menu-a4-landscape"],
  "poster": ["poster"],
  "business-card": ["biz-card-landscape", "biz-card-portrait", "biz-card-square"],
  "loyalty-card": ["loyalty-card-landscape", "loyalty-card-portrait"],
  "sticker": ["sticker-landscape", "sticker-portrait", "sticker-square"],
  "instagram-post": ["insta-post"],
  "instagram-story": ["insta-story"],
  "facebook-post": ["fb-post"],
  "facebook-story": ["fb-story"],
  "tabletop-insert": ["table-tent", "table-tent-insert", "table-tent-insert-4x6"],
  "logo": ["logo"],
  "sandwich-board": ["sandwich-board"],
  "food-label": ["label-landscape", "label-portrait", "label-square"],
  "gift-certificate": ["gift-certificate-landscape"],
  "comment-card": ["comment-card-portrait"],
  "rack-card": ["rack-card-portrait"],
  "custom-size": ["custom"]
}`);

export const DigitalSizes = [
  "digital-menu-board",
  "digital-menu-board-portrait",
  "fb-post",
  "fb-story",
  "insta-post",
  "insta-story",
  "logo",
];

export const SocialSizes = [
  "fb-post",
  "fb-story",
  "insta-post",
  "insta-story",
  "logo",
];

export const DigiboardSizes = [
  "digital-menu-board",
  "digital-menu-board-portrait"
]

export const MaxFreemiumLinkPageViews = 300;

export const headerHeight = '80px';
export const mobileHeaderHeight = '60px';

export const homePaths = ['/home-test', '/home-test/', '/home-test/designs', '/home-test/designs/',
                          '/home', '/home/', '/home/designs', '/home/designs/', ]

const isLocalhost = window.location.href.match('localhost');
export const isTestEnv = window.location.href.match('test.mhmfun.com');
export const isStageEnv = window.location.href.match('staging.mhmfun.com');
export const isProdEnv = window.location.href.match('musthavemenus.com');

export const homePath = isLocalhost ? '' :
                        isTestEnv ? '/home-test' :
                        isStageEnv ? '/home-stage' :
                        '/home';

export const DESIGN_IN_USE_SECONDS = 45;
export const DSA_ENABLED =
  (window.localStorage.getItem('dsa')?.toUpperCase() === 'Y') ||
  (window.location.href.indexOf("localhost") > -1) ||
  (window.location.href.indexOf("test.mhmfun") > -1);

export const maxDesignPages = 100;

export const STRIPE_DEFAULT_SETTINGS = {
  appearance: {
    variables: {
      fontFamily: "proxima-nova",
      colorTextPlaceholder: "#d9d9d9",
      colorPrimary: "#e42436",
    }
  },
  fonts: [
    {
      family: "proxima-nova",
      src: 'url("https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n4&v=3.woff")'
    },
  ]
}

export const DISABLE_USER_ADDONS = true;

export const toastReps = [
  {
    name: 'Katie Ripa',
    number: 1,
    zipCodes: [97406,97530,97520,97410,97621,97622,97623,97522,97416,97417,97523,97502,97624,97604,97733,97425,97625,97429,97731,97432,97524,97626,97737,97442,97443,97525,97527,97526,97528,97415,97447,97627,97531,97603,97602,97632,97504,97532,97633,97634,97533,97457,97462,97534,97464,97601,97535,97444,97536,97469,97537,97470,97471,97538,97539,97639,97497,97479,97540,97481,97484,97541,97486,97491,97501,97503,97494,97543,97544,97495,97496,97499]
  },
  {
    name: 'Sam Greene',
    number: 2,
    zipCodes:[13605,13302,14413,13020,13022,13026,13303,13611,14415,13736,13028,13738,13308,14478,13310,14815,14418,13030,13313,13314,14817,14818,13316,13318,13034,13035,13040,13042,14432,14433,13044,13045,13051,13052,14441,13053,14837,13054,13332,13056,13758,13334,13636,13061,13062,13063,13064,13065,13068,14456,13071,13072,14461,13073,14463,13346,14840,13784,13076,14521,14841,14842,13077,13355,14847,14851,14852,14853,14850,14854,13794,13081,13083,13084,14857,14882,13363,13364,13797,13087,13092,14860,13659,14489,14541,13402,13103,13661,13107,13803,13401,13101,13102,14863,13114,14507,13117,13118,13408,14513,14867,13121,13122,13123,13418,13814,13124,14516,13815,14518,13425,13426,13131,14527,14532,13674,13136,13832,13138,13139,13140,14873,13141,13142,14874,14876,13143,13437,13835,13144,14878,13440,13441,13442,13449,14542,14544,13145,13455,13146,14547,13148,13460,14881,13605,13464,14551,14555,13465,13154,13155,13844,14561,13157,13471,14886,13158,13159,14887,13160,13147,13478,13162,13165,13480,14893,13483,13484,13485,13486,13489,13167,13491,14588,13493,13864,14590],
  },
  {
    name: 'John Dixon',
    number: 3,
    zipCodes:[99133,99026,99185,99029,99116,99137,99129,99013,99117,99155,99173,99034,99040,99103,99123,99124,99138,99140,99147,98816,98831,98841,98862,98856,98840,98844,98855,98812,98822,98813,98846,98858,98833,98819,98830,98843,98814,98849,98852,98811,98817,98827,98829,98834,83801,83802,83803,83804,83805,83806,83808,83809,83810,83811,83812,83813,83821,83822,83823,83824,83826,83827,83830,83833,83834,83836,83837,83839,83841,83842,83845,83846,83847,83848,83849,83850,83851,83852,83853,83855,83856,83857,83858,83860,83861,83864,83866,83867,83868,83869,83870,83871,83872,83873,83874,83876,99128,98859,99003,99004,99005,99006,99009,99011,99012,99018,99021,99022,99023,99025,99030,99031,99033,99036,99101,99109,99110,99114,99118,99119,99121,99126,99130,99131,99139,99141,99146,99148,99149,99150,99151,99152,99153,99156,99157,99158,99160,99166,99167,99170,99176,99180,99181,59801,59802,59803,59804,59808,59820,59821,59824,59831,59833,59834,59842,59844,59845,59846,59847,59848,59851,59853,59855,59859,59860,59864,59865,59866,59867,59872,59873,59874,59910,59917,59918,59923,59925,59927,59930,59933,59934,59935,59806,59807,59812,59830,59856,59863,83825,83840,83865,99014,99039,99104,99107,99174,83888],
  },
  {
    name: 'Marcus LaRose',
    number: 4,
    zipCodes:[92008,92009,92010,92013,92018,92056,92054,92057,92069,92078,92083,92084,92049,92051,92052,92058,92068,92079,92081,92085,92096],
  },
  {
    name: 'Drake Skinner',
    number: 5,
    zipCodes:[85554,85362,85361,85358,85390,85321,85641,85742,85739,85736,85735,85752,85646,85639,85553,85354,85280,85273,85544,85637,86338,86351,86336,86341,86340,86339,85633,85631,85550,85629,85545,85324,85648,86335,85654,86314,86312,86301,86313,86304,85634,85079,85547,85541,85624,85737,85623,85662,85628,85621,85087,86017,85619,85342,86038,85539,86333,85239,85653,85618,85341,85339,86342,86332,85237,86331,86329,85235,86024,86303,85622,85614,85218,85502,85501,85337,85931,85232,85231,86327,85333,86343,86326,85652,86325,85228,85332,85532,86324,86323,85738,85222,86322,85322,85601,85645,85640,85320,85755,86315,85192,85194,85193,85138,85135,85137,85139,85130,85128,85131,85132,85141,85172,85145,85173,85147,85658,85121,85123,85122,85190,85191,85118,85119],
  }
]